import React from "react";
import { Row, Col } from "reactstrap";
import { Link } from 'react-router-dom';

function DatabaseTabItems(props) {
	return (
		<div className="tab-pane" id="database">
			<Row className="row">
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Microsoft SQL Server</p>
						<p className="box-body">
							An intelligent, relational database service which
							you can set up, operate, and scale with few clicks.
						</p>
						<Link className="learn-more" to="/microsqlserver" target="_blank">
							Learn more <span className="learn-arrow"></span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">MySQL</p>
						<p className="box-body">
							Enterprise-ready, fully managed community MySQL.
						</p>
						<Link className="learn-more" to="/mysql" target="_blank">
							Learn more <span className="learn-arrow"></span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Oracle RDS</p>
						<p className="box-body">
							Oracle database setup and operation easier than
							ever.
						</p>
						<Link className="learn-more" to="/oracle" target="_blank">
							Learn more <span className="learn-arrow"></span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">HANA RDS</p>
						<p className="box-body">
							Use the huge capabilities of SAP HANA in your cloud.
						</p>
						<Link className="learn-more" to="saphana" target="_blank">
							Learn more <span className="learn-arrow"></span>
						</Link>
					</div>
				</Col>
			</Row>
		</div>
	);
}

export default DatabaseTabItems;
